module.exports = "/assets/75436cf8e50cb53d454f9a4b691ae7fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/PG.png
// module id = 1715
// module chunks = 0